import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lightbulb } from 'lucide-react';

const InnovationFAB = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/innovation-challenge');
  };

  return (
    <div style={styles.fabContainer}>
      <button
        style={styles.fab}
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Innovation Challenge"
        className="innovation-fab"
      >
        <Lightbulb size={24} color="white" strokeWidth={2.5} />
        
        {/* Pulse Ring Animation */}
        <div style={styles.pulseRing} className="pulse-ring"></div>
      </button>

      {/* Tooltip */}
      {showTooltip && (
        <div style={styles.tooltip} className="fab-tooltip">
          Innovation Challenge
          <div style={styles.tooltipArrow}></div>
        </div>
      )}
    </div>
  );
};

const styles = {
  fabContainer: {
    position: 'fixed',
    top: '100px',
    right: '32px',
    zIndex: 1000
  },
  fab: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #F4CE7B 0%, #FFD98E 100%)',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(244, 206, 123, 0.4), 0 8px 24px rgba(0, 0, 0, 0.12)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'visible'
  },
  pulseRing: {
    position: 'absolute',
    top: '-4px',
    left: '-4px',
    right: '-4px',
    bottom: '-4px',
    borderRadius: '50%',
    border: '2px solid #F4CE7B',
    opacity: 0
  },
  tooltip: {
    position: 'absolute',
    right: '75px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: '#1D57D5',
    color: 'white',
    padding: '10px 16px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 12px rgba(29, 87, 213, 0.3)',
    animation: 'slideInRight 0.2s ease-out',
    letterSpacing: '0.3px'
  },
  tooltipArrow: {
    position: 'absolute',
    right: '-6px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 0,
    height: 0,
    borderLeft: '6px solid #1D57D5',
    borderTop: '6px solid transparent',
    borderBottom: '6px solid transparent'
  }
};

// Add styles for animations
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  .innovation-fab:hover {
    transform: scale(1.1) translateY(-2px);
    box-shadow: 0 6px 24px rgba(244, 206, 123, 0.5), 0 12px 32px rgba(0, 0, 0, 0.15) !important;
  }
  
  .innovation-fab:active {
    transform: scale(1.05) translateY(-1px);
  }
  
  .innovation-fab:hover .pulse-ring {
    animation: pulseRing 1.5s ease-out infinite;
  }
  
  @keyframes pulseRing {
    0% {
      transform: scale(0.95);
      opacity: 1;
    }
    100% {
      transform: scale(1.3);
      opacity: 0;
    }
  }
  
  @keyframes slideInRight {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(10px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }
  
  .fab-tooltip {
    animation: slideInRight 0.2s ease-out;
  }
  
  /* Mobile responsiveness - position at top right */
  @media (max-width: 768px) {
    .innovation-fab {
      width: 52px !important;
      height: 52px !important;
    }
    
    .fab-tooltip {
      display: none !important;
    }
  }
  
  /* Accessibility */
  .innovation-fab:focus {
    outline: 3px solid rgba(29, 87, 213, 0.5);
    outline-offset: 2px;
  }
  
  .innovation-fab:focus:not(:focus-visible) {
    outline: none;
  }
`;

// Only append if not already added
if (!document.getElementById('innovation-fab-styles')) {
  styleSheet.id = 'innovation-fab-styles';
  document.head.appendChild(styleSheet);
}

export default InnovationFAB;
